import { render, staticRenderFns } from "./MenuBarsRecucler.vue?vue&type=template&id=638d58b7&"
import script from "./MenuBarsRecucler.vue?vue&type=script&lang=ts&"
export * from "./MenuBarsRecucler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports